import { CommonModule } from '@angular/common'
import { FolderExportModalComponent } from './folder-export-modal/folder-export-modal.component'
import { FolderOverviewActivityComponent } from './folder-overview-activity/folder-overview-activity.component'
import { FolderOverviewComponent } from './foder-overview/folder-overview.component'
import { FolderOverviewDetailsComponent } from './folder-overview-details/folder-overview-details.component'
import { FolderOverviewFolderComponent } from './folder-overview-folder/folder-overview-folder.component'
import { FolderOverviewFolderContainerComponent } from './folder-overview-folder/folder-overview-folder-container.component'
import { FolderOverviewFooterComponent } from './folder-overview-footer/folder-overview-footer.component'
import { FolderOverviewNgrxModule } from './folder-overview-ngrx.module'
import { FolderOverviewRetainedTeamsComponent } from './folder-overview-retained-teams/folder-overview-retained-teams.component'
import { FolderOverviewRetainerBreakdownComponent } from './folder-overview-retainer-breakdown/folder-overview-retainer-breakdown.component'
import { FolderOverviewRoutingModule } from './folder-overview.routing.module'
import { FolderTrafficModalComponent } from './folder-traffic-modal/folder-traffic-modal.component'
import { LoaderModalModule } from '@app/shared/components/loader-modal/loader-modal.module'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { NameEditorModule } from '@app/shared/components/name-editor/name-editor.module'
import { NgModule } from '@angular/core'
import { PipesModule } from '@app/shared/pipe/index.module'
import { ScopeElementsModule } from '@app/shared/components/scope-elements/scope-elements.module'
import { ScopeUiCheckboxComponent } from '@app/shared/components/ui-components/scope-ui-checkbox/scope-ui-checkbox.component'
import { ScopeUiDropdownComponent } from '@app/shared/components/ui-components/scope-ui-dropdown/scope-ui-dropdown.component'
import { ScopeUiInputComponent } from '@app/shared/components/ui-components/scope-ui-input/scope-ui-input.component'
import { ScopeUiOptionsMenuComponent } from '@app/shared/components/scope-ui-options-menu/scope-ui-options-menu.component'
import { ScopeUiTabComponent } from '@app/shared/components/ui-components/scope-ui-tab/scope-ui-tab.component'
import { ScopeUiTableComponent } from '@app/shared/components/ui-components/scope-ui-table/scope-ui-table.component'
import { ScopeUiTabsComponent } from '@app/shared/components/ui-components/scope-ui-tabs/scope-ui-tabs.component'
import { SharedModule } from '@app/shared/shared.module'

@NgModule({
  declarations: [
    FolderOverviewComponent,
    FolderOverviewFooterComponent,
    FolderExportModalComponent,
    FolderTrafficModalComponent,
    FolderOverviewActivityComponent,
    FolderOverviewDetailsComponent,
    FolderOverviewFolderContainerComponent,
    FolderOverviewFolderComponent,
    FolderOverviewRetainedTeamsComponent,
    FolderOverviewRetainerBreakdownComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule,
    LoaderModalModule,
    NameEditorModule,
    ScopeElementsModule,
    ScopeUiTabsComponent,
    ScopeUiTabComponent,
    ScopeUiTableComponent,
    ScopeUiInputComponent,
    ScopeUiDropdownComponent,
    ScopeUiCheckboxComponent,
    ScopeUiOptionsMenuComponent,
    MatIconModule,
    MatDividerModule,
    FolderOverviewNgrxModule,
    FolderOverviewRoutingModule,
  ],
})
export class FolderOverviewModule {}
